import { useDispatch, useSelector } from 'react-redux';
import { FormCategoriesPlansPage } from '../../CategoriesPlans/pages/form/view';
import {
  GetAccounts,
  CreateAccounts,
  DeleteAccounts,
  GetAccountById,
  UpdateAccounts,
} from '../../../store/actions';

/**
 * AccountsInjection is responsible for injecting the data into the Accounts page.
 *
 * @return
 *  getAccounts: () => Void
 * 	removeAccounts: () => Void
 * 	updateAccounts: () => Void
 *  deleteAccounts: () => void
 *  loadingAccount: boolean
 *  errorAccount: string
 *  accounts: object
 */
export const AccountsInjection = () => {
  /* constants */
  const dispatch = useDispatch();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   * @return Void
   */
  const getAccounts = async () => {
    dispatch(GetAccounts());
  };

  /**
   * @return Void
   */
  const getAccountById = async (id) => {
    dispatch(GetAccountById(id));
  };

  /**
   * @return Void
   */
  const deleteAccounts = async (id) => {
    dispatch(DeleteAccounts(id));
  };

  /**
   * @return void
   */
  const createAccounts = async (data, history) => {
    dispatch(CreateAccounts(data, history));
  };

  /**
   * @return void
   */
  const updateAccounts = async (id, data, history) => {
    dispatch(UpdateAccounts(id, data, history));
  };

  /**
   * @variables
   *
   * error: string
   * loading: boolean
   * user: object
   */
  const { accounts, success, error, loading, accountById } = useSelector(
    (state) => ({
      loading: state.Accounts.loading,
      error: state.Accounts.error,
      accounts: state.Accounts.accounts,
      accountById: state.Accounts.accountById,
      success: state.Accounts.success,
    })
  );

  return {
    errorAccount: '',
    loadingAccount: FormCategoriesPlansPage,
    accounts,
    success,
    getAccounts,
    deleteAccounts,
    createAccounts,
    updateAccounts,
    getAccountById,
    accountById,
  };
};
